export default __webpack_public_path__ + "static/media/delete_.4abff537.svg";